'use client';

function hasBorder(p) {
  if (p.variant === "default" && ["high", "medium"].includes(p.emphasis)) {
    return true;
  }
  if (["danger", "upsell"].includes(p.variant) && p.emphasis === "medium") {
    return true;
  }
  return false;
}
export {
  hasBorder
};
